export const RW_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM = 'motorPrivateRwanda/personalDetailsForm/';

export const MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE = RW_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM + 'setValue/';
export const MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID = RW_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM + 'setValid/';

export const FORM_VALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM =
    'motorPrivateRwanda/personalDetailsForm/transition/formValid';
export const FORM_INVALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM =
    'motorPrivateRwanda/personalDetailsForm/transition/formInValid';

export const REINITIALIZE = 'motorPrivateRwanda/personalDetailsForm/state/reinitialize';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS_FORM =
    'motorPrivateRwanda/personalDetailsForm/transition/dropOffLead';
export const dropOffLeadPersonalDetails = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS_FORM,
    value,
});

export const transitionMotorInsurancePersonalDetailsForm = {
    formValid: () => ({
        type: FORM_VALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM = `${MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM = `${MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM = `${MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/failure`;
export const API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM = `${MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/initial`;

export const apiTransitionPersonalDetailsForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    initial: () => ({
        type: API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
};

//calculated Data
export const COLLECT_PERSONAL_DETAILS_FORM_DATA =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'collectPersonalDetailsData';
export const SUBMIT_PERSONAL_DETAILS_SUCCESS = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'success';
export const SUBMIT_PERSONAL_DETAILS_FAILURE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'failure';

export const collectPersonalDetailsData = () => ({
    type: COLLECT_PERSONAL_DETAILS_FORM_DATA,
});
export const submitPersonalDetailsDataSuccess = (value) => ({
    type: SUBMIT_PERSONAL_DETAILS_SUCCESS,
    value,
});
export const submitPersonalDetailsFailure = (error) => ({
    type: SUBMIT_PERSONAL_DETAILS_FAILURE,
    error,
});

// Form Values
export const CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'calculateAmlWhitelist';

export const GENDER_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'gender';
export const GENDER_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'gender';

export const FIRST_NAME_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'firstName';
export const FIRST_NAME_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'firstName';

export const LAST_NAME_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'lastName';
export const LAST_NAME_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'lastName';

export const NATIONALITY_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'nationality';
export const NATIONALITY_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'nationality';

export const DOB_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'DOB';
export const DOB_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'DOB';

export const OCCUPATION_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'occupation';
export const OCCUPATION_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'occupation';

export const ID_NUMBER_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'idNumber';
export const ID_NUMBER_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'idNumber';

export const PASSPORT_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'passport';
export const PASSPORT_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'passport';

export const ID_TYPE_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'idType';
export const ID_TYPE_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'idType';

export const PHONE_NUMBER_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'phoneNumber';
export const PHONE_NUMBER_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'phoneNumber';

export const EMAIL_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'email';

export const SALUTATION_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'salutation';
export const SALUTATION_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'salutation';

export const DISTRICT_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'district';
export const DISTRICT_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'district';

export const SECTOR_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'sector';
export const SECTOR_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'sector';

export const CELL_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'cell';
export const CELL_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'cell';

export const VILLAGE_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'village';
export const VILLAGE_SET_VALID = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALID + 'village';

export const NIDA_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'nida';

export const SELECTED_FORM_SET_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'selectedForm';

export const TRIGGER_GET_NATIONALITIES = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'fetch/nationalities';
export const TRIGGER_GET_NIDA = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'fetch/nida';
export const SET_NATIONALITIES_VALUE = MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'set/nationalities';
export const API_FAILURE_TRANSITION_NATIONALITIES =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'api/failure/nationalities';
export const API_SUCCESS_TRANSITION_NATIONALITIES =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'api/success/nationalities';
export const API_PENDING_TRANSITION_NATIONALITIES =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'api/pending/nationalities';

    export const API_FAILURE_TRANSITION_NIDA =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'api/failure/nida';
export const API_SUCCESS_TRANSITION_NIDA =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'api/success/nida';
export const API_PENDING_TRANSITION_NIDA =
    MOTOR_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE + 'api/pending/nida';

export const PERSONAL_DETAILS_AML_WHITELIST = 'personalDetails/amlWhitelist/';

export const TRIGGER_AML_WHITELIST_CHECK = PERSONAL_DETAILS_AML_WHITELIST + 'check/';

export const triggerAmlWhitelistCheck = () => ({
    type: TRIGGER_AML_WHITELIST_CHECK,
});

// action creators
export const calculatePersonalDetailsAmlWhitelistSuccess = (value) => ({
    type: CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS,
    value,
});

export const setGenderValue = (value) => ({
    type: GENDER_SET_VALUE,
    value,
});

export const setGenderValid = (error) => ({
    type: GENDER_SET_VALID,
    error,
});

export const setNationalityValue = (value) => ({
    type: NATIONALITY_SET_VALUE,
    value,
});

export const setNationalityValid = (error) => ({
    type: NATIONALITY_SET_VALID,
    error,
});

export const setOccupationValue = (value) => ({
    type: OCCUPATION_SET_VALUE,
    value,
});

export const setOccupationValid = (error) => ({
    type: OCCUPATION_SET_VALID,
    error,
});

export const setIdNumberValue = (value) => ({
    type: ID_NUMBER_SET_VALUE,
    value,
});

export const setIdNumberValid = (error) => ({
    type: ID_NUMBER_SET_VALID,
    error,
});

export const setPassportValue = (value) => ({
    type: PASSPORT_SET_VALUE,
    value,
});

export const setPassportValid = (error) => ({
    type: PASSPORT_SET_VALID,
    error,
});

export const setIdTypeValue = (value) => ({
    type: ID_TYPE_SET_VALUE,
    value,
});

export const setIdTypeValid = (error) => ({
    type: ID_TYPE_SET_VALID,
    error,
});

export const setPostalAddressValue = (value) => ({
    type: ADDRESS_SET_VALUE,
    value,
});

export const setPostalAddressValid = (error) => ({
    type: ADDRESS_SET_VALID,
    error,
});

export const setFirstNameValue = (value) => ({
    type: FIRST_NAME_SET_VALUE,
    value,
});
export const setFirstNameValid = (error) => ({
    type: FIRST_NAME_SET_VALID,
    error,
});

export const setLastNameValue = (value) => ({
    type: LAST_NAME_SET_VALUE,
    value,
});
export const setLastNameValid = (error) => ({
    type: LAST_NAME_SET_VALID,
    error,
});

export const setPhoneNumberValue = (value) => ({
    type: PHONE_NUMBER_SET_VALUE,
    value,
});
export const setPhoneNumberValid = (error) => ({
    type: PHONE_NUMBER_SET_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});
export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setDOBValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});
export const setDOBValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setSalutationValue = (value) => ({
    type: SALUTATION_SET_VALUE,
    value,
});
export const setSalutationValid = (error) => ({
    type: SALUTATION_SET_VALID,
    error,
});

export const setSectorValue = (value) => ({
    type: SECTOR_SET_VALUE,
    value,
});
export const setSectorValid = (error) => ({
    type: SECTOR_SET_VALID,
    error,
});

export const setDistrictValue = (value) => ({
    type: DISTRICT_SET_VALUE,
    value,
});
export const setDistrictValid = (error) => ({
    type: DISTRICT_SET_VALID,
    error,
});

export const setCellValue = (value) => ({
    type: CELL_SET_VALUE,
    value,
});
export const setCellValid = (error) => ({
    type: CELL_SET_VALID,
    error,
});

export const setVillageValue = (value) => ({
    type: VILLAGE_SET_VALUE,
    value,
});
export const setVillageValid = (error) => ({
    type: VILLAGE_SET_VALID,
    error,
});

export const setSelectedFormValue = (value) => ({
    type: SELECTED_FORM_SET_VALUE,
    value,
});

export const apiTransitionNationalities = {
    pending: () => ({
        type: API_PENDING_TRANSITION_NATIONALITIES,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_NATIONALITIES,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_NATIONALITIES,
    }),
};

export const apiTransitionNida = {
    pending: () => ({
        type: API_PENDING_TRANSITION_NIDA,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_NIDA,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_NIDA,
    }),
};

export const triggerGetNationalities = () => ({
    type: TRIGGER_GET_NATIONALITIES,
});

export const setNationalitiesList = (value) => ({
    type: SET_NATIONALITIES_VALUE,
    value,
});

export const setNidaValue = (value) => ({
    type: NIDA_SET_VALUE,
    value,
});

export const triggerNida = () => ({
    type: TRIGGER_GET_NIDA,
});